// extracted by mini-css-extract-plugin
module.exports = {"card":"SelectionMainCard_card__hsvZh","title":"SelectionMainCard_title__qzeqr","promo":"SelectionMainCard_promo__awVac","favorite":"SelectionMainCard_favorite__S8tpZ"};